module.exports = __webpack_public_path__ + "img/change2.ea77ec4d.png";